import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { DisabledTooltip } from "../disabled-tooltip";
import styles from "./dialog-footer.module.scss";
import type { DialogFooterViewProps, FooterButtonViewProps } from "./types-dialog-footer";

/** Botão do rodapé dentro do `DisabledTooltip` do DS, sempre: o botão não troca de pai quando o `tooltip` liga e desliga (o `tooltip` do Prime não chega ao `Button`). */
function BotaoDoRodape({ tooltip, ...botao }: FooterButtonViewProps) {
  return (
    <DisabledTooltip content={tooltip}>
      <Button {...botao} />
    </DisabledTooltip>
  );
}

/** A árvore não muda com a terceira ação: o `div.acoes` é sempre o pai do Confirmar. */
export function DialogFooterView({
  className,
  empilhado,
  rest,
  cancelProps,
  confirmProps,
  extraProps,
}: DialogFooterViewProps) {
  return (
    <div className={classNames(styles.footer, empilhado && styles.empilhado, className)} {...rest}>
      <BotaoDoRodape {...cancelProps} />
      <div className={styles.acoes}>
        {extraProps ? <BotaoDoRodape {...extraProps} /> : null}
        <BotaoDoRodape {...confirmProps} />
      </div>
    </div>
  );
}
